'use client';

import type { PropsWithChildren } from 'react';
import { useState } from 'react';

import { QueryClientProvider, QueryClient } from '@tanstack/react-query';

function QueryProvider({ children }: PropsWithChildren) {
  const [client] = useState(new QueryClient({}));

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}

export { QueryProvider };
